import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import LegalPublicLayout from "./LegalPublicLayout";
import { LegalSectionBody } from "./LegalSectionBody";
import type { LegalSectionBlock } from "./legalSectionTypes";

const sections: LegalSectionBlock[] = [
  {
    title: "1. Informații generale",
    content:
      "Această politică de confidențialitate descrie modul în care Visaj Technologies SRL, cu următoarele date de identificare:",
    bullets: [
      "CUI: 40191040",
      "Sediu social: Strada Rândunicii nr. 9, Giroc, Timiș, România",
      "Email: aifoiparcurs@visaj.ro",
      "Telefon: 0726 678 127",
    ],
    footer:
      "colectiv denumită „Operatorul”, prelucrează datele cu caracter personal ale utilizatorilor aplicației AiFoiParcurs.",
  },
  {
    title: "2. Ce este AiFoiParcurs",
    content: "AiFoiParcurs este o aplicație web și mobilă care permite:",
    bullets: [
      "completarea automată a foilor de parcurs;",
      "validarea acestora;",
      "gestionarea deplasărilor vehiculelor de firmă;",
      "evidența alimentărilor.",
    ],
  },
  {
    title: "3. Ce date colectăm",
    content: "În cadrul aplicației pot fi colectate următoarele categorii de date:",
    groups: [
      {
        label: "Date de identificare",
        items: ["Nume și prenume", "Email", "Număr de telefon", "Date firmă (denumire, CUI etc.)"],
      },
      {
        label: "Date operaționale",
        items: [
          "Date vehicul",
          "Trasee și locații parcurse (inclusiv coordonate)",
          "Istoric deplasări",
        ],
      },
      {
        label: "Date despre alimentări",
        items: ["Număr bon", "Cantitate alimentată", "Preț", "Dată alimentare"],
      },
      {
        label: "Date tehnice",
        items: ["Adresă IP", "Cookie-uri"],
      },
    ],
  },
  {
    title: "4. Scopul prelucrării",
    content: "Datele sunt colectate pentru:",
    bullets: [
      "furnizarea serviciilor aplicației;",
      "generarea și validarea foilor de parcurs;",
      "gestionarea conturilor utilizatorilor;",
      "procesarea plăților;",
      "îmbunătățirea serviciilor;",
      "respectarea obligațiilor legale.",
    ],
  },
  {
    title: "5. Temeiul legal",
    content: "Prelucrăm datele în baza:",
    bullets: [
      "executării contractului, pentru utilizarea aplicației;",
      "obligațiilor legale;",
      "interesului legitim, pentru securitate și îmbunătățirea serviciilor;",
      "consimțământului, pentru cookies, dacă este cazul.",
    ],
  },
  {
    title: "6. Plăți online",
    content: "Plățile sunt procesate prin intermediul NETOPIA Payments.",
    bullets: [
      "Operatorul nu stochează datele cardului bancar;",
      "datele de plată sunt procesate securizat de către procesatorul de plăți;",
      "NETOPIA acționează ca operator independent de date.",
    ],
  },
  {
    title: "7. Terți și servicii utilizate",
    content: "Putem transmite date către:",
    bullets: [
      "Google, pentru servicii de geocoding;",
      "ANAF, pentru identificare firmă după CUI;",
      "servicii de hosting, de exemplu Railway.",
    ],
    footer: "Aceste servicii pot prelucra date conform propriilor politici.",
  },
  {
    title: "8. Stocarea datelor",
    content:
      "Datele sunt stocate pe servere securizate, pe durata necesară furnizării serviciului și conform obligațiilor legale.",
  },
  {
    title: "9. Drepturile utilizatorilor",
    content: "Conform GDPR, aveți următoarele drepturi:",
    bullets: [
      "dreptul de acces;",
      "dreptul la rectificare;",
      "dreptul la ștergere;",
      "dreptul la restricționare;",
      "dreptul la portabilitate;",
      "dreptul la opoziție.",
    ],
    footer: "Pentru exercitarea acestor drepturi: aifoiparcurs@visaj.ro",
  },
  {
    title: "10. Cookie-uri",
    content: "Aplicația utilizează cookie-uri pentru:",
    bullets: ["funcționare;", "analiză;", "îmbunătățirea experienței."],
    footer: "Utilizatorii vor fi informați printr-un banner dedicat.",
  },
  {
    title: "11. Securitatea datelor",
    content: "Luăm măsuri tehnice și organizatorice pentru:",
    bullets: [
      "protejarea datelor;",
      "prevenirea accesului neautorizat;",
      "securizarea comunicațiilor.",
    ],
  },
  {
    title: "12. Modificări ale politicii",
    content:
      "Ne rezervăm dreptul de a modifica această politică. Versiunea actualizată va fi publicată pe site.",
  },
  {
    title: "13. Contact",
    content: "Pentru întrebări privind protecția datelor: aifoiparcurs@visaj.ro",
  },
];

export default function PoliticaConfidentialitatePage() {
  return (
    <LegalPublicLayout>
      <Seo {...seoFromPublicPage("/politica-de-confidentialitate")} />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Politica de Confidențialitate</p>
            <h1 className="legal-doc__title">Politica de Confidențialitate - AiFoiParcurs</h1>

            <div className="legal-doc__sections">
              {sections.map((section) => (
                <LegalSectionBody key={section.title} section={section} />
              ))}
            </div>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
